// Данные главной для всех четырёх адресов («/», /ru, /az, /en): число открытых
// стран (пин «за рубежом») и ссылки блока «Populyar» (29.10.2026) — страницы
// предметов с анкетами и две свежие статьи блога. Любой сбой — без этой части,
// главная рисуется.
import type { HomeLang } from "./HomePage";
import type { PopularData } from "./HomePopular";
import { listBlogPosts } from "@/lib/blog.functions";
import { getEduCountriesCount } from "@/lib/edu-countries-count.functions";
import { getSubjectPages } from "@/lib/map-public.functions";

export type HomeLoad = { countries: number | null; popular: PopularData };

export async function loadHome(lang: HomeLang): Promise<HomeLoad> {
  const [countries, subjects, blog] = await Promise.all([
    getEduCountriesCount().catch(() => null),
    getSubjectPages().catch(() => ({ pages: [] as { code: string; n: number }[] })),
    listBlogPosts({ data: { lang, page: 1 } }).catch(() => ({ cards: [], total: 0 })),
  ]);
  return {
    countries: countries?.count ?? null,
    popular: {
      subjects: subjects.pages,
      posts: blog.cards.slice(0, 2).map((c) => ({ slug: c.slug, title: c.title })),
    },
  };
}
